import Soccer1Rules from "./content/howto/soccer-1";
import Soccer4Rules from "./content/howto/soccer-4";
import Soccer5Rules from "./content/howto/soccer-5";
import Soccer6Rules from "./content/howto/soccer-6";
import Soccer7Rules from "./content/howto/soccer-7";
import Soccer8Rules from "./content/howto/soccer-8";
import Soccer10Rules from "./content/howto/soccer-10";
import Soccer11Rules from "./content/howto/soccer-11";
import MegastrikeRules from "./content/howto/megastrike";
import Soccer13Rules from "./content/howto/soccer-13";
import Soccer13XRules from "./content/howto/soccer-13x";

// PoolTypeConfig: what each Pool Type is, in one place (see GLOSSARY.md).
//
//   id:         the pool_id used in props, API paths and archive URLs.
//   name:       the customer-facing name. Page titles other than the Results and
//               archive pages' still write their own wording, which varies, so
//               they don't read this yet.
//   live:       false for a Discontinued Pool Type, whose URLs must keep resolving.
//               Its pools and tips pages, which have nothing to list, go to its
//               archive page instead (see ArchiveRedirect).
//   slugs:      the URL slug per section (see App.js), a list where a section has
//               several routes to the same page.
//   howto:      the how-to-play page:
//                 title  the page heading
//                 rules  the rule texts, from src/content/howto/
//   matchCount: the number of matches in a Program. Free2Play has none of its own,
//               as its Programs belong to other Pool Types.
//   matchLabels: set only where the matches aren't numbered M1 to Mn.
//   result:     how this Pool Type's Results render, on the Results and archive
//               pages. Free2Play has none, as its Programs belong to other Pool Types:
//                 label             text after the date in the heading, e.g. "S1"
//                 hidesProgramCode  true where the heading leaves out "(Program Code)"
//                 teamAHeading      the Team A column heading, where it isn't "Team A"
//                 scoreHeading      the score column heading, where it isn't "Score"
//                 topTier           set for a tiered Payout panel: the tier always shown,
//                                   e.g. "10/10". Without it the panel has a single dividend.
//                 lowerTiers        the tiers listed before it, each shown only when it
//                                   has winners
//                 emptyTier         the lower tier that shows zeros when nobody won it
//                 tierFields        the Payout field ending per tier, where it isn't the
//                                   tier itself, e.g. { "15/15": "13_15" }
//                 pendingPrefix     the start of the League Title that picks this Pool
//                                   Type's Programs out of the pending Results
//                 resultsTitle      the Results page's name for it, where it isn't `name`
//                 archiveTitle      the archive page's name for it, where it isn't `name`
//   tips:       how <Tips> renders this Pool Type's Tips:
//                 stake         rand cost of one combination, multiplied by the perms
//                 betType       the TAB bet type in the BET NOW link, e.g. "WN"
//                 tipster       the heading's right-hand label, "Expert" if unset
//                 renameLeague  { from, to } replaced once in the League Title, so
//                               Mega 10's "S11 V1 P1" shows "Mega 10 JackpotV1 P1"
//                 permMatches   the matches the Suggested Perm lists, if not all of
//                               them. Soccer 13's has always shown M11 twice.
//                 pickedMatchesOnly  true where the tipster picks some of the matches
//                               (Soccer 13X). A "-" selection shows as "_" in the
//                               perm, and the link numbers only the picked matches.
//                 permSplits    positions in the Suggested Perm where its " x " is two
//                               text nodes, " x" and " ", as the old S{N}Tips had them.
//                               Chrome measures text nodes separately, so this keeps
//                               the table's column widths identical to the pixel.
export const poolTypes = [
  {
    id: 1,
    name: "Soccer 1",
    live: true,
    slugs: { pools: ["soccer-1", "soccer1-advanced"], results: "soccer-1", tips: "soccer-1", howToPlay: "soccer-1", archive: "soccer-1" },
    howto: { title: "How To Play - Soccer 1", rules: Soccer1Rules },
    matchCount: 1,
    result: { label: "S1", pendingPrefix: "S1 " },
    tips: { stake: 6, betType: "WN" },
  },
  {
    id: 2,
    name: "Soccer 2",
    live: false,
    slugs: { archive: "soccer-2" },
    matchCount: 2,
    result: { label: "S1", hidesProgramCode: true },
  },
  {
    id: 4,
    name: "Soccer 4",
    live: true,
    slugs: { pools: ["soccer-4", "soccer4-advanced"], simpleToday: "soccer-4", results: "soccer-4", tips: "soccer-4", howToPlay: "soccer-4", archive: "soccer-4" },
    howto: { title: "How To Play - Soccer 4", rules: Soccer4Rules },
    matchCount: 4,
    result: { label: "S4", hidesProgramCode: true, pendingPrefix: "S4 " },
    tips: { stake: 6, betType: "JP" },
  },
  {
    id: 5,
    name: "Soccer Scores",
    live: false,
    slugs: { pools: ["soccer-5", "soccer5-advanced"], results: "soccer-5", tips: "soccer-5", howToPlay: "soccer-5", archive: "soccer-5" },
    howto: { title: "How To Play - Soccer Scores", rules: Soccer5Rules },
    matchCount: 6,
    result: { label: "SS", topTier: "6/6", lowerTiers: ["1/6", "2/6", "3/6", "4/6", "5/6"], pendingPrefix: "SS " },
  },
  {
    id: 6,
    name: "Soccer 6",
    live: true,
    slugs: { pools: ["soccer-6", "soccer6-advanced"], simpleToday: "soccer-6", results: "soccer-6", tips: "soccer-6", howToPlay: "soccer-6", archive: "soccer-6" },
    howto: { title: "How To Play - Soccer 6", rules: Soccer6Rules },
    matchCount: 6,
    result: { label: "S6", pendingPrefix: "S6 " },
    tips: { stake: 6, betType: "P6", permSplits: [5] },
  },
  {
    id: 7,
    name: "Soccer Corners",
    live: false,
    slugs: { pools: ["soccer-7", "soccer7-advanced"], results: "soccer-7", tips: "soccer-7", howToPlay: "soccer-7", archive: "soccer-7" },
    howto: { title: "How To Play - Soccer Corners", rules: Soccer7Rules },
    matchCount: 6,
    result: { label: "SS", scoreHeading: "Corners", pendingPrefix: "SC " },
  },
  {
    id: 8,
    name: "Soccer 8 HF",
    live: false,
    slugs: { pools: ["soccer-8", "soccer8-advanced"], results: "soccer-8", tips: "soccer-8", howToPlay: "soccer-8", archive: "soccer-8" },
    howto: { title: "How To Play - Soccer 8", rules: Soccer8Rules },
    matchCount: 8,
    matchLabels: ["M1H", "M2F", "M3H", "M4F", "M5H", "M6F", "M7H", "M8F"],
    result: { label: "S8", hidesProgramCode: true, pendingPrefix: "S8 " },
    tips: { stake: 6, betType: "P8", permSplits: [5] },
  },
  {
    id: 10,
    name: "Soccer 10",
    live: true,
    slugs: { pools: ["soccer-10", "soccer10-advanced"], simpleToday: "soccer-10", results: "soccer-10", tips: "soccer-10", howToPlay: "soccer-10", archive: "soccer-10" },
    howto: { title: "How To Play - Soccer 10", rules: Soccer10Rules },
    matchCount: 10,
    result: { label: "S10", topTier: "10/10", lowerTiers: ["9/10"], pendingPrefix: "S10 " },
    tips: { stake: 2, betType: "PT", permSplits: [5] },
  },
  {
    id: 11,
    name: "Mega 10 Jackpot",
    live: true,
    slugs: { pools: ["soccer-11", "soccer-mega-10"], results: "soccer-11", tips: "soccer-11", howToPlay: "soccer-11", archive: "soccer-11" },
    howto: { title: "How To Play - Mega 10 Jackpot", rules: Soccer11Rules },
    matchCount: 10,
    result: {
      label: "Soccer Mega 10 Jackpot",
      topTier: "10/10",
      lowerTiers: ["9/10"],
      pendingPrefix: "S11 ",
      resultsTitle: "Soccer Mega 10 Jackpot",
      archiveTitle: "Soccer Mega10 Jackpot",
    },
    tips: { stake: 3, betType: "PT", renameLeague: { from: "S11 ", to: "Mega 10 Jackpot" }, permSplits: [5] },
  },
  {
    id: 12,
    name: "Megastrike",
    live: false,
    slugs: { pools: "megastrike", results: "soccer-12", howToPlay: "megastrike", archive: "megastrike10" },
    howto: { title: "How To Play - MegaStrike 10", rules: MegastrikeRules },
    matchCount: 10,
    result: {
      label: "Megastrike 10",
      hidesProgramCode: true,
      teamAHeading: "Player(Team)",
      scoreHeading: "Goals",
      topTier: "10/10",
      lowerTiers: ["9/10"],
      pendingPrefix: "Megastrike ",
      resultsTitle: "MegaStrike 10",
      archiveTitle: "Megastrike 10",
    },
  },
  {
    id: 13,
    name: "Soccer 13",
    live: true,
    slugs: { pools: ["soccer-13", "soccer13-advanced"], simpleToday: "soccer-13", results: "soccer-13", tips: "soccer-13", howToPlay: "soccer-13", archive: "soccer-13" },
    howto: { title: "How To Play - Soccer 13", rules: Soccer13Rules },
    matchCount: 13,
    result: { label: "S13", topTier: "13/13", lowerTiers: ["10/13", "11/13", "12/13"], emptyTier: "10/13", pendingPrefix: "S13 " },
    tips: { stake: 2, betType: "PE", tipster: "Experts", permMatches: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 11, 13], permSplits: [5, 12] },
  },
  {
    id: 15,
    name: "Soccer Any 15",
    live: false,
    slugs: { archive: "soccer-15" },
    matchCount: 30,
    result: {
      label: "S15",
      hidesProgramCode: true,
      topTier: "15/15",
      lowerTiers: ["14/15"],
      tierFields: { "14/15": "12_15", "15/15": "13_15" },
    },
  },
  {
    id: 16,
    name: "Soccer Any 13 Xtra",
    live: true,
    slugs: {
      pools: ["soccer-13-extra", "soccer16-advanced"],
      simpleToday: "soccer-16",
      results: "soccer-13-extra",
      tips: "soccer-13-extra",
      howToPlay: "soccer-13x",
      archive: "soccer-13X",
    },
    howto: { title: "How To Play - Soccer Any 13 Xtra", rules: Soccer13XRules },
    matchCount: 30,
    result: { label: "S13X", topTier: "13/13", lowerTiers: ["12/13", "11/13", "10/13", "9/13", "8/13"], pendingPrefix: "S13X " },
    tips: { stake: 2, betType: "CD", pickedMatchesOnly: true },
  },
  {
    id: 20,
    name: "Free2Play",
    live: true,
    slugs: { pools: "free2p" },
  },
];

// Takes a number, or the string id from an archive URL. The string must be the
// id exactly, so "06" isn't Soccer 6.
export const poolTypeById = (id) => poolTypes.find((poolType) => String(poolType.id) === String(id));

export const matchLabels = (poolType) => poolType.matchLabels ?? Array.from({ length: poolType.matchCount ?? 0 }, (_, i) => "M" + (i + 1));
